import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { GameAction, GameCollectionAction, GamingExternalState } from "@obg/gaming.external";
import { batchActions } from "@obg/ngrx-utils";

import { MyOffersLobbyComponent } from "./my-offers-lobby.component";
import { MyOffersLobbyEffects } from "./my-offers-lobby.effects";

@NgModule({
	declarations: [MyOffersLobbyComponent],
	imports: [CommonModule, EffectsModule.forFeature(MyOffersLobbyEffects)],
	exports: [MyOffersLobbyComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyOffersLobbyModule {
	constructor(store: Store<GamingExternalState>, gameCollectionAction: GameCollectionAction) {
		store.dispatch(batchActions(GameAction.getGames(), gameCollectionAction.getAll()));
	}
}
